import { render, staticRenderFns } from "./BlogPostsCategories.vue?vue&type=template&id=06fb7163&"
import script from "./BlogPostsCategories.vue?vue&type=script&lang=js&"
export * from "./BlogPostsCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports